import { NgTemplateOutlet } from '@angular/common';
import { Component, input, output } from '@angular/core';

import { PrivaCardComponent } from '@priva/components/card';

import { promotedGroupName } from '../../constants';
import { EmployeeGroup } from '../../models';

@Component({
    selector: 'app-employee-navigation',
    templateUrl: './employee-navigation.component.html',
    styleUrl: './employee-navigation.component.scss',
    imports: [PrivaCardComponent, NgTemplateOutlet],
})
export class EmployeeNavigationComponent {
    employeeGroups = input(undefined, {
        transform: (value: EmployeeGroup[]) => {
            this.employeeGroupNameList = value.map((gr) => gr.groupName);
        },
    });

    navigate = output<string>();
    closeNavigation = output<void>();

    promotedGroupName = promotedGroupName;
    employeeGroupNameList: string[] = [];

    onNavigate(groupName: string): void {
        this.navigate.emit(groupName);
    }

    onClose(): void {
        this.closeNavigation.emit();
    }
}
